<div class="dialog">
  <div class="row">
    <div class="col-md-6">
      <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
    </div>
    <div class="col-md-6 align-right">
      <button
        type="button"
        class="btn btn-xs btn-success"
        (click)="addSeason()"
        *ngIf="listMode && permissions.canCreate"
      >
        <i class="fa fa-plus"></i> {{ 'ADD_SEASON' | translate }}
      </button>
      <button type="button" class="btn btn-xs" (click)="showSeasons()" *ngIf="detailMode">
        <i class="fa fa-angle-left"></i> {{ 'BACK' | translate }}
      </button>

      <span class="dialog-close" (click)="close()">
        <i class="fa fa-close"></i>
      </span>
    </div>
  </div>

  <div class="dialog-content">
    <div *ngIf="listMode">
      <div *ngIf="permissions.canList">
        <app-season-list
          [seasons]="seasons"
          [meta]="meta"
          [loadingSeasons]="loadingSeasons"
          [defaultLanguage]="defaultLanguage"
          (selectedSeason)="onSelectedSeason($event)"
        ></app-season-list>
      </div>
      <div *ngIf="!permissions.canList">INVALID ACCESS</div>
    </div>

    <div *ngIf="detailMode">
      <app-season-detail
        [season]="season"
        [mode]="mode"
        [defaultLanguage]="defaultLanguage"
        [additionalLanguages]="additionalLanguages"
        [isModal]="true"
        (savedSeason)="onSavedSeason($event)"
        (canceledSeason)="onCanceledSeason()"
      ></app-season-detail>
    </div>
  </div>
</div>
